import React, { useState } from "react";
import { clearAdminToken } from "../../api";

export type AdminSection = "events" | "promo" | "meetings" | "manual" | "availability" | "contacts";

export function AdminShell({ active, title, children }: { active: AdminSection; title: string; children: React.ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [
    { id: "events" as const, href: "/admin", label: "Event тохиргоо", icon: "+" },
    { id: "promo" as const, href: "/admin/promo", label: "Promo", icon: "★" },
    { id: "meetings" as const, href: "/admin/bookings", label: "Бүх захиалгууд", icon: "▣" },
    { id: "manual" as const, href: "/admin/manual-booking", label: "Гараар booking", icon: "✎" },
    { id: "availability" as const, href: "/admin/availability", label: "Availability", icon: "◷" },
    { id: "contacts" as const, href: "/admin/contacts", label: "Contacts", icon: "@" },
  ];

  function logout() {
    clearAdminToken();
    window.location.href = "/admin";
  }

  return (
    <main className={`admin-shell admin-${active}`}>
      <button
        className="admin-menu-toggle"
        type="button"
        aria-expanded={menuOpen}
        aria-label="Admin menu"
        onClick={() => setMenuOpen(true)}
      >
        <span />
        <span />
        <span />
      </button>
      {menuOpen && <button className="admin-menu-backdrop" type="button" aria-label="Menu хаах" onClick={() => setMenuOpen(false)} />}
      <aside className={menuOpen ? "admin-sidebar open" : "admin-sidebar"}>
        <a className="admin-brand" href="/admin" onClick={() => setMenuOpen(false)}>
          {/* <span>C</span> */}
          <strong>PicShot</strong>
        </a>
        <nav className="admin-menu">
          {links.map((link) => (
            <a className={active === link.id ? "active" : ""} href={link.href} key={link.id} onClick={() => setMenuOpen(false)}>
              <span>{link.icon}</span>
              {link.label}
            </a>
          ))}
          <a href="/" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>
            <span>↗</span>
            User тал
          </a>
        </nav>
      </aside>
      <section className="admin-content">
        <header className="admin-top">
          <div>
            <p>PicShot Admin</p>
            <h1>{title}</h1>
          </div>
          <button className="admin-logout" type="button" onClick={logout}>Гарах</button>
        </header>
        {children}
      </section>
    </main>
  );
}
